import React, { useCallback, useEffect, useRef, useState } from 'react'
import { BsBoxArrowInLeft } from 'react-icons/bs'
import { IoCreate, IoSave } from 'react-icons/io5'
import { Link, useParams } from 'react-router-dom'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { SearchBox } from '../../Components/SearchBox/SearchBox'
import { Template } from '../../Components/Template/template'
import {
    classDivBackground, classDivBody, classInput, classInputDark, classLabel, classLabelDark, classBt, classbtAzul, AlertType, classBorderLabelDark,
    classWeigthBt, classbtColunasVermelho, classbtCinzaClaro, InputsRefs, bgBlue, barraVermelhoAzul, bgRed, focusRed, focusLabelRed,
    LanctoChequeAttributes, ClientesSearchBox, BancoSearchBox, ParamsSaveCheque,
    classDtCriarAtt,
    classUserCriarAtt
} from '../../Utils/Types'
import { Funcoes } from '../../Utils/Funcoes'
import moment from 'moment'
import { ControleChequesService } from './ControleChequesService'
import { AiOutlineClear } from 'react-icons/ai'
import { FaRegQuestionCircle } from 'react-icons/fa'
import { Tooltip } from 'react-tooltip'
import { faClipboardList, faFolder } from '@fortawesome/free-solid-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Icone } from '../../Components/Icones/Index'

export const LanctoChequePage = () => {

    // ----------------- TABS --------------------------------------------------------
    type Tab = {
        index: number,
        titulo: String,
        active: boolean,
        icon: IconProp,
    }

    const itabs: Tab[] = [
        { index: 0, titulo: 'Dados Principais', active: true, icon: faFolder },
        { index: 1, titulo: 'Auditoria', active: false, icon: faClipboardList },
    ]

    const [tabs, setTabs] = useState<Tab[]>(itabs)


    // --------------------------- ATRIBUTOS -----------------------------------
    const { idDoCheque } = useParams<string>()
    const [idCheque, setIdCheque] = useState<number>(0)
    const [attributes, setAttributes] = useState<LanctoChequeAttributes>()

    let date = moment().utcOffset('-03:00').format('YYYY-MM-DD')

    const [tipo_cheque, setTipo_cheque] = useState<string>("P")
    const [nome_terceiro, setNome_Terceiro] = useState<string>("")

    const [idBanco, setIdBanco] = useState<number>(0)
    const [bancoList, setBancoList] = useState<BancoSearchBox[]>([])

    const [conta, setConta] = useState<string>('')
    const [conta_digito, setConta_Digito] = useState<string>("")
    const [data_lancamento, setData_Lancamento] = useState<string>(date)
    const [dt_bom_para, setDt_Bom_Para] = useState<string>("")
    const [agencia, setAgencia] = useState<string>('')
    const [agencia_digito, setAgencia_Digito] = useState<string>("")
    const [numero, setNumero] = useState<string>("")
    const [valor, setValor] = useState<string>("")
    const [status, setStatus] = useState<string>("N")

    const [idCliente, setIdCliente] = useState<number>(0)
    const [clientesList, setClientesList] = useState<ClientesSearchBox[]>([])

    const [observacao, setObservacao] = useState<string>("")

    // ---------- ATRIBUTOS AUDITORIA -------------------------------------------------
    const [userCriador, setUserCriador] = useState("")
    const [dtCriador, setDtCriador] = useState("")
    const [usertAtt, setUsertAtt] = useState("")
    const [dtAtt, setDtAtt] = useState("")

    // --------------------------- ATRIBUTOS FEEDBACK -----------------------------------
    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // --------------------------- ATRIBUTOS SEARCHBOX -----------------------------------
    const [visibleSearchBoxBanco, setVisibleSearchBoxBanco] = useState<boolean>(false)
    const [visibleSearchBoxCliente, setVisibleSearchBoxCliente] = useState<boolean>(false)


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ATRIBUTOS E EFFECT --------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ || 
    const GetAttributes = async () => {
        setLoading(true)

        try {

            const attr = await ControleChequesService.GetAttributes(idDoCheque)

            setAttributes(attr.data)
            setClientesList(attr.data.clientes)
            setBancoList(attr.data.bancos)

            if (attr.data && idDoCheque) {

                const banco = attr.data.bancos.filter((item: any) => item.id === attr.data.cheque?.id_banco)
                if (banco && banco.length > 0) {
                    setIdBanco(banco[0].id)
                }

                const cliente = attr.data.clientes.filter((item: any) => item.id === attr.data.cheque?.id_cliente)
                if (cliente && cliente.length > 0) {
                    setIdCliente(cliente[0].id)
                }

                setIdCheque(attr.data.cheque.id)
                setTipo_cheque(attr.data.cheque.tipo_cheque || "P")
                setNome_Terceiro(attr.data.cheque.nome_terceiro || '')
                setConta(attr.data.cheque.conta?.toString() || '')
                setConta_Digito(attr.data.cheque.conta_digito || '')
                setData_Lancamento(attr.data.cheque.data_lancamento || '')
                setDt_Bom_Para(attr.data.cheque.dt_bom_para || '')
                setAgencia(attr.data.cheque.agencia?.toString() || '')
                setAgencia_Digito(attr.data.cheque.agencia_digito || '')
                setNumero(attr.data.cheque.numero || '')
                setValor(attr.data.cheque.valor?.toString() || '')
                setStatus(attr.data.cheque.status || '')
                setObservacao(attr.data.cheque.observacao || '')

                setUserCriador(attr.data.cheque.name_user_insert || '')
                setUsertAtt(attr.data.cheque.name_user_last_update || '')

                if (attr.data.cheque.dt_cadastro) {
                    const dataFormatadaCriacao = moment(attr.data.cheque.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (attr.data.cheque.dt_last_update) {
                    const dataFormatadaAtt = moment(attr.data.cheque.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage("Não foi possível buscar os dados do banco/cliente")

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        GetAttributes()

        const timer = setTimeout(() => {
            inputFocus()
            clearTimeout(timer)
        }, 150)

    }, [])

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        inputFocus()
    }, [])

    const handleChangeTab = async (tab: number) => {
        let newTabs = await tabs.map((item) => {
            if (item.index === tab) {
                itabs[item.index].active = true
            } else {
                itabs[item.index].active = false
            }
            return itabs[item.index]
        })
        setTabs(newTabs)
    }

    useEffect(() => {

        if (tabs[0].active) {
            inputFocus()
        }

    }, [tabs])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- INPUTS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleChangeTipoCheque = (e: React.ChangeEvent<HTMLSelectElement>) => {

        const fieldMap: { [key: string]: string } = {
            'P': 'P',
            'T': 'T',
        }

        const selectedField = fieldMap[e.target.value]

        if (selectedField) {
            setTipo_cheque(selectedField)
            //inputFocus()
        }
    }

    const handleChangeNomeTerceiro = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNome_Terceiro(e.target.value)
    }

    const handleChangeDtLancamento = (e: React.ChangeEvent<HTMLInputElement>) => {
        setData_Lancamento(e.target.value)
    }

    const handleChangeDtBomPara = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDt_Bom_Para(e.target.value)
    }

    const handleChangeAgencia = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAgencia(e.target.value)
    }

    const handleChangeAgenciaDigito = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAgencia_Digito(e.target.value.replace(/[^0-9]/g, ''))
    }

    const handleChangeConta = (e: React.ChangeEvent<HTMLInputElement>) => {
        setConta(e.target.value)
    }

    const handleChangeContaDigito = (e: React.ChangeEvent<HTMLInputElement>) => {
        setConta_Digito(e.target.value.replace(/[^0-9]/g, ''))
    }

    const handleChangeNumero = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumero(e.target.value.replace(/[^0-9]/g, ''))
    }

    const handleChangeValor = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValor(Funcoes.MaskMoney(e.target.value))
    }

    const handleChangeStatus = (e: React.ChangeEvent<HTMLSelectElement>) => {

        const fieldMap: { [key: string]: string } = {
            'N': 'N',
            'D': 'D',
            'R': 'R',
        }

        const selectedField = fieldMap[e.target.value]

        if (selectedField) {
            setStatus(selectedField)
        }
    }

    const handleChangeObservacao = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setObservacao(e.target.value)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- BANCOS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearBancoSelecionado = useCallback(() => {

        setIdBanco(0)

        setVisibleSearchBoxBanco(false)
        boxFocusBanco()
    }, [attributes?.bancos])

    const handleSetBancoClick = useCallback((v: BancoSearchBox) => {

        if (v) {
            const newBancoList = [...attributes?.bancos || []]
            setBancoList(newBancoList)
            setIdBanco(v.id)
        }

        setVisibleSearchBoxBanco(false)
        boxFocusBanco()
    }, [attributes?.bancos])

    const handleFilterBancoClick = useCallback((description: any) => {

        if (description === "") {

            const newUfList = [...attributes?.bancos || []]
            setBancoList(newUfList)

        } else {

            let newBancos

            if (!isNaN(description)) {

                newBancos = [...attributes?.bancos || []].filter((banco) => {
                    const codigoSubstring = banco.id.toString().substring(0, 3)
                    return codigoSubstring.startsWith(description)
                })

            } else {

                newBancos = [...attributes?.bancos || []].filter((banco) => banco.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase()))
            }

            setBancoList(newBancos)
        }
    }, [attributes?.bancos])

    const boxFocusBanco = () => {
        // Move o foco para o input correspondente à chave 'banco'.
        inputsRefs['banco'].current?.focus()
    }

    const clickSearchBoxBanco = useCallback(() => {
        setVisibleSearchBoxBanco((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxCliente(false)
                inputFocusBanco()
            }
            return newState
        })

        boxFocusBanco()
    }, [])

    const inputFocusBanco = () => {
        let inputSearch = document.getElementById(`inputSearchBox-banco`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CLIENTE -------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearClienteSelecionado = useCallback(() => {

        setIdCliente(0)

        setVisibleSearchBoxCliente(false)
        boxFocusCliente()
    }, [attributes?.clientes])

    const handleSetClienteClick = useCallback(async (v: ClientesSearchBox) => {

        if (v) {
            const newClienteList = [...attributes?.clientes || []]
            setClientesList(newClienteList)
            setIdCliente(v.id)
        }

        setVisibleSearchBoxCliente(false)
        boxFocusCliente()

    }, [attributes?.clientes])

    const handleFilterClienteClick = useCallback(async (description: string) => {

        if (description === "") {

            const newClienteList = [...attributes?.clientes || []]
            setClientesList(newClienteList || [])

        } else {

            const newClienteList = [...attributes?.clientes || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setClientesList(newClienteList || [])
        }

    }, [attributes?.clientes])

    const boxFocusCliente = () => {
        // Move o foco para o input correspondente à chave 'uf'.
        inputsRefs['cliente'].current?.focus()
    }

    const clickSearchBoxCliente = useCallback(() => {
        setVisibleSearchBoxCliente((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxBanco(false)
                inputFocusCliente()
            }
            return newState
        })

        boxFocusCliente()
    }, [])

    const inputFocusCliente = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cliente`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------ CHEQUES --------------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const novoLancamentoCheque = () => {

        setIdCheque(0)
        setTipo_cheque("P")
        setNome_Terceiro("")
        setIdBanco(0)
        setConta("")
        setConta_Digito("")
        setData_Lancamento(date)
        setDt_Bom_Para("")
        setAgencia("")
        setAgencia_Digito("")
        setNumero("")
        setValor("")
        setStatus("N")
        setIdCliente(0)
        setObservacao("")

        setDtCriador('')
        setUserCriador('')
        setDtAtt('')
        setUsertAtt('')

        searchBoxFocus()
        inputFocus()

        if (messageType === 'DANGER') {
            setVisible(false)
        }
    }

    const handleSaveCheque = async () => {

        setVisible(false)
        setLoading(true)

        try {

            searchBoxFocus()

            const cheque: ParamsSaveCheque = {
                id: idCheque,
                tipo_cheque: tipo_cheque,
                nome_terceiro: nome_terceiro,
                id_banco: idBanco,
                conta: conta,
                conta_digito: conta_digito,
                data_lancamento: data_lancamento,
                dt_bom_para: dt_bom_para,
                agencia: agencia,
                agencia_digito: agencia_digito,
                numero: numero,
                valor: parseFloat(valor),
                id_cliente: idCliente,
                observacao: observacao,
                status: status
            }

            const resp = await ControleChequesService.Save(cheque)

            if (resp.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(resp.msg || '')

            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setIdCheque(resp.id || 0)
                setMessage(idCheque > 0 ? 'Lançamento de cheque atualizado com sucesso.' : 'Lançamento de cheque efetuado com sucesso.')

                if (resp.dt_cadastro) {
                    const dataFormatadaCriacao = moment(resp.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (resp.dt_last_update) {
                    const dataFormatadaAtt = moment(resp.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setUserCriador(resp.name_user_insert || '')
                setUsertAtt(resp.name_user_last_update || '')

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(idCheque > 0 ? 'Houve um erro ao atualizar o lançamento do cheque.' : 'Houve um erro ao efetuar o lançamento do cheque.')

        } finally {
            setLoading(false)
        }
    }

    const inputFocus = () => {
        const inputElement = document.getElementById("tipo_cheque")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- TAB ------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefs: InputsRefs = {
        tipoCheque: useRef(null),
        nomeTerceiro: useRef(null),
        banco: useRef(null),
        conta: useRef(null),
        digitoConta: useRef(null),
        dataLancamento: useRef(null),
        dataVencimento: useRef(null),
        agencia: useRef(null),
        digitoAgencia: useRef(null),
        numero: useRef(null),
        valor: useRef(null),
        status: useRef(null),
        cliente: useRef(null),
        observacao: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab') {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            searchBoxFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length
            } while (
                (inputsRefs[keys[nextIndex]].current?.disabled || inputsRefs[keys[nextIndex]].current?.tabIndex === -1) &&
                nextIndex !== currentIndex
            )

            //console.log("nextIndex: ", nextIndex)

            if (nextIndex === 2) {
                setVisibleSearchBoxBanco(true)
                inputFocusBanco()
            }

            if (nextIndex === 12) {
                setVisibleSearchBoxCliente(true)
                inputFocusCliente()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            inputsRefs[keys[nextIndex]].current?.focus()
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab') {

                event.preventDefault()

                const inputSearchBanco = document.getElementById('inputSearchBox-banco') as HTMLInputElement
                const inputSearchCliente = document.getElementById('inputSearchBox-cliente') as HTMLInputElement

                if (document.activeElement === inputSearchBanco) {

                    inputsRefs['conta'].current?.focus()
                    setVisibleSearchBoxBanco(false)

                } else if (document.activeElement === inputSearchCliente) {
                    inputsRefs['observacao'].current?.focus()
                    setVisibleSearchBoxCliente(false)
                }
            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    const searchBoxFocus = () => {
        setVisibleSearchBoxBanco(false)
        setVisibleSearchBoxCliente(false)
    }

    const btNovoVisible = parseInt(idDoCheque || '') > 0 ? 'invisible hidden' : 'visible'

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`h-[50px] w-full flex items-center my-3 px-2`}>

                            <div className={`flex items-center h-[50px]`}>
                                <IoCreate className={`mr-2 ml-4 text-slate-700 dark:text-slate-200`} size="25px" />
                                <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>{parseInt(idDoCheque || '') || idCheque > 0 ? `Lançamentos de Cheques - Editar` : `Lançamentos de Cheques`}</span>
                            </div>

                        </div>

                        <div className={`w-full h-full`}>

                            <div className={`h-[60px] flex overflow-x-auto scrollable_horizontal border border-slate-200 dark:border-slate-700`}>
                                {tabs.map((item) => {
                                    return (
                                        <button tabIndex={-1} onClick={() => handleChangeTab(item.index)} key={item.index.toString()}
                                            className={`px-4 font-mono font-bold w-[180px]
                                                                                    ${item.active ?
                                                    `hover:text-sky-500 text-sky-600 border border-b-[3px] border-l-0 border-t-0 border-r-slate-300 border-b-sky-600 dark:text-slate-200 dark:border-r-slate-700 dark:border-b-slate-300` :
                                                    `text-sky-600 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 border border-l-0 border-t-0 border-b-0 dark:border-slate-800`
                                                } `}>
                                            <div tabIndex={-1} className={`flex items-center whitespace-nowrap`}>
                                                <span className={`mr-2`}><Icone icon={item.icon} /></span>
                                                <span className={`text-sm roboto whitespace-nowrap`}>{item.titulo}</span>
                                            </div>
                                        </button>
                                    )
                                })}

                            </div>

                            <div className={`${tabs[0].active ? 'block' : 'hidden'} relative`}>

                                <div className={`w-full grid gap-4 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 space-y-1`}>
                                        <div className={`flex flex-row `}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>Dados do Cheque</span>
                                            <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 `} size={18} />
                                            <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                            </Tooltip>
                                        </div>
                                        <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2 mt-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue} `} />
                                        <select ref={inputsRefs.tipoCheque} onKeyDown={(e) => handleTabPress(e, 'tipoCheque')} id='tipo_cheque' className={`${classInput} ${classInputDark}`} value={tipo_cheque} onFocus={searchBoxFocus} onChange={handleChangeTipoCheque} >
                                            <option value="P">Próprio</option>
                                            <option value="T">Terceiro</option>
                                        </select>
                                        <label htmlFor="tipo_cheque" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Tipo Cheque</label>
                                    </div>

                                    <div className={`${tipo_cheque === 'P' ? `hidden` : `visible`} relative col-span-12 sm:col-span-9 xl:col-span-5 mt-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.nomeTerceiro} onKeyDown={(e) => handleTabPress(e, 'nomeTerceiro')} id="nomeTerceiro" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={155} placeholder=" " autoComplete='off' disabled={tipo_cheque === 'P' ? true : false} value={nome_terceiro} onFocus={searchBoxFocus} onChange={handleChangeNomeTerceiro} />
                                        <label htmlFor="nomeTerceiro" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Nome Terceiro</label>
                                    </div>

                                    <div className={`relative col-span-12 ${tipo_cheque === 'P' ? `md:col-span-9` : `md:col-span-6`} xl:col-span-5 mt-2`}>

                                        <div ref={inputsRefs['banco']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'banco')} />
                                        <div className={`${barraVermelhoAzul} ${idBanco > 0 ? bgBlue : bgRed}`} />
                                        <SearchBox
                                            dataList={bancoList}
                                            idRegistro={idBanco}
                                            label='Banco'
                                            componentId='banco'
                                            limite={true}
                                            borda={true}
                                            visibleTAB={visibleSearchBoxBanco}
                                            clearDataClick={handleClearBancoSelecionado}
                                            setDataClick={handleSetBancoClick}
                                            filterDataClick={handleFilterBancoClick}
                                            clicado={clickSearchBoxBanco}
                                        />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-2`}>
                                        <div className={`${barraVermelhoAzul} ${conta != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.conta} onKeyDown={(e) => handleTabPress(e, 'conta')} id="conta" className={`${classInput} ${classInputDark} ${conta != '' ? '' : focusRed}`} type='text' inputMode='numeric' maxLength={20} placeholder=" " autoComplete='off' value={conta} onFocus={searchBoxFocus} onChange={handleChangeConta} />
                                        <label htmlFor="conta" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${conta != '' ? '' : focusLabelRed}`}>Conta</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 md:col-span-2 xl:col-span-1 mt-2`}>
                                        <div className={`${barraVermelhoAzul} ${conta_digito != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.digitoConta} onKeyDown={(e) => handleTabPress(e, 'digitoConta')} id="contaDigito" className={`${classInput} ${classInputDark} ${conta_digito != '' ? '' : focusRed}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={conta_digito} onFocus={searchBoxFocus} onChange={handleChangeContaDigito} />
                                        <label htmlFor="contaDigito" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${conta_digito != '' ? '' : focusLabelRed}`}>Dígito</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 md:col-span-3 xl:col-span-2 mt-2`}>
                                        <div className={`${barraVermelhoAzul} ${data_lancamento != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.dataLancamento} onKeyDown={(e) => handleTabPress(e, 'dataLancamento')} id="dataLancamento" className={`${classInput} ${classInputDark} ${data_lancamento != "" ? `` : `text-blue-500 dark:text-cyan-300 ${focusRed}`} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=" " value={data_lancamento} onFocus={searchBoxFocus} onChange={handleChangeDtLancamento} />
                                        <label htmlFor="dataLancamento" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${data_lancamento != '' ? '' : focusLabelRed}`}>Data Lançamento</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 md:col-span-3 xl:col-span-2 mt-2`}>
                                        <div className={`${barraVermelhoAzul} ${dt_bom_para != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.dataVencimento} onKeyDown={(e) => handleTabPress(e, 'dataVencimento')} id="dataBomPara" className={`${classInput} ${classInputDark} ${dt_bom_para != '' ? '' : focusRed} ${dt_bom_para === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=" " value={dt_bom_para} onFocus={searchBoxFocus} onChange={handleChangeDtBomPara} />
                                        <label htmlFor="dataBomPara" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${dt_bom_para != '' ? '' : focusLabelRed}`}>Data de Vencimento</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-2`}>
                                        <div className={`${barraVermelhoAzul} ${agencia != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.agencia} onKeyDown={(e) => handleTabPress(e, 'agencia')} id="agencia" className={`${classInput} ${classInputDark} ${agencia != '' ? '' : focusRed}`} type='text' inputMode='numeric' maxLength={20} placeholder=" " autoComplete='off' value={agencia} onFocus={searchBoxFocus} onChange={handleChangeAgencia} />
                                        <label htmlFor="agencia" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${agencia != '' ? '' : focusLabelRed}`}>Agência</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 md:col-span-2 xl:col-span-1 mt-2`}>
                                        <div className={`${barraVermelhoAzul} ${agencia_digito != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.digitoAgencia} onKeyDown={(e) => handleTabPress(e, 'digitoAgencia')} id="agenciaDigito" className={`${classInput} ${classInputDark} ${agencia_digito != '' ? '' : focusRed}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={agencia_digito} onFocus={searchBoxFocus} onChange={handleChangeAgenciaDigito} />
                                        <label htmlFor="agenciaDigito" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${agencia_digito != '' ? '' : focusLabelRed}`}>Dígito</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 md:col-span-2 xl:col-span-1 mt-2`}>
                                        <div className={`${barraVermelhoAzul} ${numero != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.numero} onKeyDown={(e) => handleTabPress(e, 'numero')} id="numero" className={`${classInput} ${classInputDark} ${numero != '' ? '' : focusRed}`} type='text' inputMode='numeric' maxLength={40} placeholder=" " autoComplete='off' value={numero} onFocus={searchBoxFocus} onChange={handleChangeNumero} />
                                        <label htmlFor="numero" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${numero != '' ? '' : focusLabelRed}`}>Número</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 md:col-span-2 xl:col-span-1 mt-2`}>
                                        <div className={`${barraVermelhoAzul} ${parseFloat(valor) > 0 ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.valor} onKeyDown={(e) => handleTabPress(e, 'valor')} id="valor" className={`${classInput} ${classInputDark} ${parseFloat(valor) > 0 ? '' : focusRed}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={valor} onFocus={searchBoxFocus} onChange={handleChangeValor} />
                                        <label htmlFor="valor" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${parseFloat(valor) > 0 ? '' : focusLabelRed}`}>Valor</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 md:col-span-2 xl:col-span-2 mt-2 `}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <select ref={inputsRefs.status} onKeyDown={(e) => handleTabPress(e, 'status')} id='status' disabled={parseInt(idDoCheque || '0') <= 0} className={`${classInput} ${classInputDark} ${parseInt(idDoCheque || '0') <= 0 ? `cursor-not-allowed` : ''}`} value={status} onFocus={searchBoxFocus} onChange={handleChangeStatus} >
                                            <option value="N">Normal</option>
                                            <option value="D">Devolvido</option>
                                            <option value="R">Representado</option>
                                        </select>
                                        <label htmlFor="status" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Status</label>
                                    </div>

                                    <div className={`relative col-span-12 md:col-span-6 xl:col-span-3 mt-2`}>

                                        <div ref={inputsRefs['cliente']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'cliente')} />
                                        <div className={`${barraVermelhoAzul} ${idCliente > 0 ? bgBlue : bgRed}`} />
                                        <SearchBox
                                            dataList={clientesList}
                                            idRegistro={idCliente}
                                            label='Cliente'
                                            componentId='cliente'
                                            borda={true}
                                            visibleTAB={visibleSearchBoxCliente}
                                            clearDataClick={handleClearClienteSelecionado}
                                            setDataClick={handleSetClienteClick}
                                            filterDataClick={handleFilterClienteClick}
                                            clicado={clickSearchBoxCliente}
                                        />
                                    </div>

                                    <div className={`relative col-span-12 mt-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue} bottom-1 dark:bottom-1`} />
                                        <textarea ref={inputsRefs.observacao} onKeyDown={(e) => handleTabPress(e, 'observacao')} id="obs" className={`${classInput} ${classInputDark} min-h-[160px] lg:min-h-[120px] resize-none`} maxLength={155} placeholder=" " autoComplete='off' value={observacao} onFocus={searchBoxFocus} onChange={handleChangeObservacao} />
                                        <label htmlFor="obs" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Observação</label>
                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <Link tabIndex={-1} to="/c_cheque" className={`${classbtColunasVermelho} ${classWeigthBt}`} onMouseUp={handleMouseUp}>
                                        <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                                    </Link>

                                    <button tabIndex={-1} className={`${classBt} ${btNovoVisible}  ${classbtCinzaClaro} ${classWeigthBt}`} onClick={novoLancamentoCheque} >
                                        <AiOutlineClear size="20px" className='mr-[5px]' />Limpar Campos
                                    </button>

                                    <button tabIndex={-1} className={`${classBt} ${classbtAzul} ${classWeigthBt}`} onClick={handleSaveCheque}>
                                        {!loading && <IoSave size="16px" className='mr-[5px]' />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {parseInt(idDoCheque || '0') > 0 || idCheque != 0 ? !loading ? `Atualizar` : `Aguarde` : !loading ? `Salvar` : `Aguarde`}

                                    </button>

                                </div>

                            </div>

                            <div className={`${tabs[1].active ? 'block' : 'hidden'} relative h-[400px] sm:h-[200px]`}>

                                <div className={`w-full h-full flex flex-row p-4`}>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userCriacaoGrupo" className={`${classUserCriarAtt}`}>Criador</label>
                                            <span id="userCriacaoGrupo" className={`${classDtCriarAtt}`} >{userCriador}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtCriacaoGrupo" className={`${classUserCriarAtt}`}>Data de Criação</label>
                                            <span id="dtCriacaoGrupo" className={`${classDtCriarAtt}`} >{dtCriador}</span>
                                        </div>

                                    </div>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userAttGrupo" className={`${classUserCriarAtt}`}>Atualizador</label>
                                            <span id="userAttGrupo" className={`${classDtCriarAtt}`} >{usertAtt}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtAttGrupo" className={`${classUserCriarAtt}`}>Data de Atualização</label>
                                            <span id="dtAttGrupo" className={`${classDtCriarAtt}`}>{dtAtt}</span>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </Template>
    )
}